module.exports = __webpack_public_path__ + "assets/img/banner-services-540.jpg";